import { Router } from '@angular/router';
import { Component, OnInit, ViewEncapsulation, SimpleChanges, Renderer2, OnDestroy } from '@angular/core';

import { Observable } from 'rxjs';

import { BaseVraagControlDirective } from '../base/base-vraag-control';
import { Vraag, Antwoord, Vraagtype, EigenRisicoTekst, Controltype } from '@models/claims';
import { IBaseVraagboomResultaat, SchademeldenState, VraagboomAntwoord, VraagboomEmptyResultaat } from '@models/vragenboom';
import { DataService } from '../../../services/data.service';
import { FormatHelper } from '@services/public_api';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-succes',
  templateUrl: './succes.component.html',
  styleUrls: ['./succes.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class SuccesComponent extends BaseVraagControlDirective<VraagboomEmptyResultaat> implements OnInit, OnDestroy {
  controltype = Controltype;
  vraagtitel: string;
  kenmerkenDisplayValue: string;
  vraagtype = Vraagtype;
  status: SchademeldenState;
  verz_er: string[];
  hash = '';
  resultaten$: Observable<VraagboomAntwoord<IBaseVraagboomResultaat>[]>;
  polisnummer: string;
  kenmerk_titel: string;
  kenmerken: string[];

  constructor(
    private router: Router,
    private renderer: Renderer2,
    _dataService: DataService) {
    super(_dataService);
  }

  ngOnInit() {
    if (this.vraag.vraagtype !== Vraagtype.Telefoon) {
      this.renderer.addClass(document.body, 'ols-succes');
    }
    this.resultaten$ = this._dataService.resultaten;
    this.resultaten$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
        if (res !== undefined && res !== null) {
          this.verwerkResultaten(res);
        }
      });
  }

  opmakenEigenrisico(tekst: string, eigenRisico: string): string {
    if (!tekst) {
      return '';
    }
    if (eigenRisico?.length > 0) {
      tekst = tekst.replace('{eigenrisico}', eigenRisico);
    }
    return tekst.replace(/€ /g, '€&nbsp;');
  }

  verwerkResultaten(resultaten: VraagboomAntwoord<IBaseVraagboomResultaat>[]): void {
    this.verz_er = [];
    let dekkingen: string[] = [];
    let eigenRisicoTekst: EigenRisicoTekst[] = [];
    let eigenRisico = '';
    this.hash = '';
    this.kenmerken = [];
    this.polisnummer = '';
    this.kenmerk_titel = '';
    let vraagInResultaten = false;

    for (const resultaat of resultaten) {
      if (resultaat.vraag.id === this.vraag.id) {
        vraagInResultaten = true;
      }
      for (const antwoord of resultaat.antwoorden) {
        if (antwoord.dekkingen?.length > 0) {
          dekkingen = antwoord.dekkingen;
        }
        if (antwoord.eigenrisico?.length > 0) {
          eigenRisico = antwoord.eigenrisico;
        }
        if (antwoord.tekst_eigenrisico?.length > 0) {
          eigenRisicoTekst = antwoord.tekst_eigenrisico;
        }
        if (antwoord.sleutel?.length > 0) {
          this.hash = antwoord.sleutel;
        }
        if (antwoord.polisnummer?.length > 0) {
          this.polisnummer = antwoord.polisnummer;
        }
        if (antwoord.kenmerk_titel?.length > 0) {
          this.kenmerk_titel = antwoord.kenmerk_titel;
        }
        if (antwoord.kenmerken?.length > 0) {
          this.kenmerken = antwoord.kenmerken;
        }
      }
    }
    if (!vraagInResultaten && eigenRisicoTekst.length === 0 && this.vraag.antwoorden && this.vraag.antwoorden.length > 0 && this.vraag.antwoorden[0].tekst_eigenrisico) {
      eigenRisicoTekst = this.vraag.antwoorden[0].tekst_eigenrisico;
    }

    if (eigenRisicoTekst.length > 0) {
      if (eigenRisicoTekst.length === 1) {
        if (eigenRisicoTekst[0].tekst?.length > 0) {
          // tekst_eigenrisico bevat een tekst
          for (const tekst of eigenRisicoTekst[0].tekst) {
            this.verz_er.push(this.opmakenEigenrisico(tekst, eigenRisico));
          }
        }
      } else {
        for (let dekking of dekkingen) {
          // tekst zoeken bij dekking
          if (dekking.toLowerCase().indexOf('all-risk') < 0 && (eigenRisico.length === 0 || eigenRisico === '€ 0,-')) {
            dekking = dekking + 'Nul';
          }

          for (const dekkingTekst of eigenRisicoTekst) {
            if (dekkingTekst.dekking.toLowerCase() === dekking.toLowerCase()) {
              for (const tekst of dekkingTekst.tekst) {
                this.verz_er.push(this.opmakenEigenrisico(tekst, eigenRisico));
              }
            }
          }
        }
      }
    }
    if (this.vraag?.titel?.length > 0) {
      this.vraagtitel = this.vraag.titel;

      if (this.kenmerken?.length > 0) {
        if (this.vraag.titel.substring(this.vraag.titel.length - 1) === '.') {
          this.vraagtitel = this.vraag.titel.substring(0, this.vraag.titel.length - 1);
        }
        this.kenmerkenDisplayValue = FormatHelper.stringMetSeparator(this.kenmerken, ' | ') + '.';
      }
    }
  }

  ngOnDestroy() {
    if (this.vraag.vraagtype !== Vraagtype.Telefoon) {
      this.renderer.removeClass(document.body, 'ols-succes');
    }
    super.ngOnDestroy();
  }

  initialize(changes: SimpleChanges): void { }

  validate(vraag: Vraag, antwoorden: Antwoord[], resultaat: VraagboomEmptyResultaat): boolean {
    return true;
  }

  gegevensNaarSessie(): void {
    sessionStorage.setItem('ols-pn', Number(this.polisnummer).toString());
    sessionStorage.setItem('ols-kt', this.kenmerk_titel);
    sessionStorage.setItem('ols-km', this.kenmerken ? this.kenmerken.join('|') : '');
  }

  eindeVerzekeringkiezer(): void {
    if (this.vraag && this.vraag.button_link) {
      if (this.vraag.control === Controltype.SuccesFutureState) {
        this.gegevensNaarSessie();
      }
      if (this.vraag.button_link.startsWith('https://') || this.vraag.button_link.startsWith('http://')) {
        window.open(this.vraag.button_link, '_blank');
      } else {
        this.router.navigate(['/externalRedirect', { externalUrl: this.vraag.button_link, externalUrlTitle: this.vraag.link_text }]);
      }
    } else {
      this.setAntwoord(this.vraag.antwoorden, new VraagboomEmptyResultaat());
    }
  }

  naarSchadetail(): void {
    if (this.vraag && this.vraag.button_link?.length > 0 && this.hash.length > 0) {
      window.open(this.vraag.button_link + this.hash, '_blank');
    }
  }

  geefPazaProces(): string {
    return this._dataService.getMeetidPazaProces();
  }
}
